<script setup>
import { useSupabaseUser } from '#imports'

const router = useRouter()
const supabase = useSupabaseClient()
const user = useSupabaseUser()
const isLoggedIn = ref(!!user.value)

// Nav Styles
const activeLink = ref('home')
const setActiveLink = (link) => {
  activeLink.value = link
}
//
const logoutUser = async () => {
  await supabase.auth.signOut()
}

onMounted(() => {
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_IN') {
      isLoggedIn.value = true
    } else if (event === 'SIGNED_OUT') {
      isLoggedIn.value = false
      router.push('/login') // Redirect to login after logout
    }
  })
  if (router.currentRoute.value.path === '/') {
    setActiveLink('home')
  } else if (router.currentRoute.value.path === '/login') {
    setActiveLink('login')
  } else if (router.currentRoute.value.path === '/users') {
    setActiveLink('users')
  }
})
</script>

<template>
  <div class="Header">
    <nav class="bg-[maroon] text-white">
      <div class="mx-4 flex justify-between items-center">
        <div>
          <NuxtLink
            to="/"
            @click="setActiveLink('home')">
            <h3 class="inline-block">Robert's Record</h3>
          </NuxtLink>
        </div>
        <div class="flex space-x-4 py-2">
          <NuxtLink
            to="/"
            :class="['text-white hover:text-[yellow]', { active: activeLink === 'home' }]"
            @click="setActiveLink('home')">
            Home
          </NuxtLink>
          <NuxtLink
            to="/contactUs"
            :class="[
              'text-white hover:text-[yellow]',
              { active: activeLink === 'contactUs' }
            ]"
            @click="setActiveLink('contactUs')">
            Contact Us
          </NuxtLink>
          <NuxtLink
            v-if="!isLoggedIn"
            to="/login"
            :class="[
              'text-white hover:text-[yellow]',
              { active: activeLink === 'jstime' }
            ]"
            @click="setActiveLink('login')">
            Login
          </NuxtLink>
          <NuxtLink
            v-if="!isLoggedIn"
            to="/register"
            :class="[
              'text-white hover:text-[yellow]',
              { active: activeLink === 'register' }
            ]"
            @click="setActiveLink('register')">
            Register
          </NuxtLink>
          <NuxtLink
            v-if="isLoggedIn"
            to="/users/"
            :class="[
              'text-white hover:text-[yellow]',
              { active: activeLink === 'users' }
            ]"
            @click="setActiveLink('users')">
            Users
          </NuxtLink>
          <button
            v-if="user"
            @click="logoutUser"
            :class="[
              'text-white hover:text-[yellow]',
              { active: activeLink === 'logout' }
            ]">
            Sign Out
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>

<style scoped>
.active {
  color: yellow;
}
.active:hover {
  color: lime;
}
</style>
